<template>
  <q-bar class="bg-white">
    <q-btn dense flat round :to="{ name: 'TradeIndex' }">
      <i class="fas fa-chevron-left"></i>
    </q-btn>
    <div class="col text-center">{{ $t('trade.title') }}</div>
  </q-bar>
  <div class="trade__detail q-pa-sm">
    <q-img src="https://cdn.quasar.dev/img/parallax1.jpg" />
    <div v-for="(tradesub, index) in tradesubs" :key="index" class="q-my-sm">
      {{ $t('trade.tradesub.serno', { data: tradesub.serno }) }}
      <br />
      {{ $t('trade.hotel.name', { data: hotel.hname }) }}
      <br />
      {{
        $t('trade.tradesub.checkInDate', {
          data: $filters.formatShortDate(tradesub.checkindate),
        })
      }}
      <br />
      {{
        $t('trade.tradesub.checkOutDate', {
          data: $filters.formatShortDate(tradesub.checkoutdate),
        })
      }}
      <br />
      {{ $t('trade.tradesub.name', { data: tradesub.name }) }}
      <br />
      {{ $t('trade.tradesub.userName', { data: personalInfo.name }) }}
      <br />
      {{ $t('trade.tradesub.userPhone', { data: personalInfo.pmsPhone }) }}
      <br />
      {{ $t('trade.tradesub.userEmail', { data: personalInfo.eMail }) }}
      <br />
      {{ $t('trade.total', { data: trade.sumprice }) }}
      <br />
      {{ $t('trade.hotel.tel', { data: hotel.ctel }) }}
      <br />
      {{ $t('trade.hotel.email', { data: hotel.cemail }) }}
      <br />
      {{
        $t('trade.hotel.address', {
          data: `${hotel.addrzone}${hotel.country}${hotel.address}`,
        })
      }}
    </div>
    <q-btn
      class="full-width q-mb-sm"
      outline
      :label="$t('trade.takeRoomCard')"
      :to="{ name: 'AccountTakeRoomCard', params: { serno: serno } }"
    />
    <q-btn
      class="full-width q-mb-sm"
      outline
      :label="$t('trade.share.title')"
      :to="{ name: 'TradeShare', params: { serno: serno } }"
    />
    <!-- <q-btn
      class="full-width q-mb-sm"
      color="primary"
      :label="$t('trade.enableSharedOrder.title')"
      :to="{ name: 'OrderEnableSharedTrade', params: { id: serno } }"
    /> -->
    <div class="q-my-sm">
      <span class="text-weight-bold">{{ $t('more.notice') }}</span>
      <br />
      <div v-html="notice"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    serno: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      hotel: {},
      notice: '',
      trade: {},
      tradesubs: [],
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
      lang: (state) => state.lang,
    }),
  },
  created() {
    this.getTradeById(this.serno)
      .then((res) => {
        this.trade = res;
        this.getHotel(this.trade.hno)
          .then((hotel) => {
            this.hotel = hotel;
          })
          .catch((err) => {
            console.log(err);

            this.$notify.create({
              type: 'negative',
              position: 'top',
              message: this.$t('hotel.getInfo.failed'),
              caption: err.response.data,
            });
          });
      })
      .catch((err) => {
        console.log(err);

        this.$notify.create({
          type: 'negative',
          position: 'top',
          message: this.$t('trade.getInfo.failed'),
          caption: err.response.data,
        });
      });

    this.getTradesub(this.serno)
      .then((res) => {
        this.tradesubs = res;
      })
      .catch((err) => {
        console.log(err);

        this.$notify.create({
          type: 'negative',
          position: 'top',
          message: this.$t('trade.getInfo.failed'),
          caption: err.response.data,
        });
      });

    this.getMoreDetail({ aboutId: 3, languageCode: this.lang })
      .then((res) => {
        this.notice = res.data.value;
      })
      .catch((err) => {
        console.log(err);

        this.$notify.create({
          type: 'negative',
          position: 'top',
          message: this.$t('more.getDetail.failed'),
          caption: err.response.data,
        });
      });
  },
  methods: {
    ...mapActions({
      getTradeById: 'trade/getTradeById',
      getTradesub: 'trade/getTradesub',
      getHotel: 'trade/getHotel',
      getMoreDetail: 'more/getMoreDetail',
    }),
  },
};
</script>
